import { Locale, locales, defaultLocale } from './config';
import { canonicalToLocalized, localizedToCanonical } from './categorySlugs.generated';

export function getLocalizedCategorySlug(canonicalSlug: string, locale: Locale): string {
  return canonicalToLocalized[locale]?.[canonicalSlug] || canonicalSlug;
}

export function getCanonicalCategorySlug(localizedSlug: string, locale: Locale): string {
  return localizedToCanonical[locale]?.[localizedSlug] || localizedSlug;
}

export function getAllLocalizedCategorySlugs(canonicalSlug: string): Record<Locale, string> {
  const result: Record<Locale, string> = {} as Record<Locale, string>;
  for (const locale of locales) {
    result[locale] = getLocalizedCategorySlug(canonicalSlug, locale);
  }
  return result;
}

export function isCategorySlug(slug: string, locale: Locale): boolean {
  return !!localizedToCanonical[locale]?.[slug];
}

export function getCategorySlugForUrl(canonicalSlug: string, locale: Locale): string {
  if (locale === defaultLocale) {
    return canonicalSlug;
  }
  return getLocalizedCategorySlug(canonicalSlug, locale);
}
